import { Col, Input, Row, Select } from 'antd'
import { IconSearch } from 'components/icons'
import Button from 'components/button/Button'
import { categoryJobVacanciesEnum } from '../hooks/jobVacancyEnum'
import { DropDownCategoryJobVacancy } from 'constants/dropdown'

interface IJobVacanciesCardHeaderProps {
  searchValueJobVacancies: string
  onChangeSearchValueJobVacancies: (value: string) => void
  onPressEnterSearchValueJobVacancies: () => void
  selectedCategoryJobVacancies: categoryJobVacanciesEnum
  onChangeSelectedCategoryJobVacancies: (value: categoryJobVacanciesEnum) => void
  onClickAddJobVacancies: () => void
}

export default function JobVacanciesCardHeader(props: IJobVacanciesCardHeaderProps) {
  return (
    <Row gutter={[4, 16]} className="w-full">
      <Col lg={{ span: 16 }} span={24}>
        <Input
          suffix={<IconSearch />}
          className="input-search w-full xl:w-2/5"
          data-testid="input_search_job_vacancies"
          placeholder="Masukkan Nama Pekerjaan"
          value={props.searchValueJobVacancies}
          onChange={e => props.onChangeSearchValueJobVacancies(e.target.value)}
          onPressEnter={props.onPressEnterSearchValueJobVacancies}
        />
      </Col>
      <Col lg={{ span: 4 }} span={24}>
        <Select
          data-testid="select_category_job_vacancy"
          value={props.selectedCategoryJobVacancies}
          className="dropdown-search"
          onChange={(updatedCategory: categoryJobVacanciesEnum) =>
            props.onChangeSelectedCategoryJobVacancies(updatedCategory)
          }
        >
          {DropDownCategoryJobVacancy.map(status => {
            return (
              <Select.Option
                data-testid={`select_category_job_vacancy_${status.value}`}
                key={status.value}
                value={status.value}
              >
                {status.label}
              </Select.Option>
            )
          })}
        </Select>
      </Col>
      <Col lg={{ span: 4 }} span={24}>
        <Button
          className="pt-3 rounded-xl pb-3 font-bold text-sm w-full"
          label="Tambah Pekerjaan"
          variant="solid-primary"
          type="submit"
          onClick={props.onClickAddJobVacancies}
        />
      </Col>
    </Row>
  )
}
